import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {UsuarioExternoService} from '../services/usuario-externo.service';
import {Observable, of} from 'rxjs';

// Este guard permite acesso apenas para usuários cujo perfil tenha administrador = true
export const roleGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const authService = inject(AuthService);
  const userService = inject(UsuarioExternoService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    if (authService.hasStorageToken()) {
      router.navigate(['/auth/session-expired']);
    } else {
      router.navigate(['/auth/login']);
    }
    return of(false);
  }

  return userService.isAdministrador();
};
